// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import util from './utils/index'
Vue.prototype.$util = util
import { preventReClick } from './utils/preventReClick' //防多次点击，重复提交
Vue.use(preventReClick);
import backend from './utils/backend'
Vue.prototype.$backend = backend

import api from './conf/api'
Vue.prototype.$api = api
import store from "./store";
import axios from 'axios'
Vue.prototype.$axios = axios    //全局注册，使用方法为:this.$axios

import service from './service/service'
Vue.prototype.$service = service
import Base64 from './assets/js/base64.js'
Vue.prototype.$Base64 = Base64;
import 'postcss-pxtorem'
import './utils/rem'
import {
  getPorivacyUrl,
  getCommonUrl
} from './utils/ruoyi.js'
Vue.prototype.getPorivacyUrl = getPorivacyUrl;
Vue.prototype.getCommonUrl = getCommonUrl;

import ElementUI from 'element-ui';
// import { getDicts } from "@/api/system/dict/data";
// Vue.prototype.getDicts = getDicts;
import 'element-ui/lib/theme-chalk/index.css';
import '../theme/index.css'
import './assets/styles/qingnio-ui.css'
import './assets/styles/element-variables.scss'
import {
  TimeDivision,
} from "@/utils/ruoyi";
Vue.prototype.TimeDivision = TimeDivision;
import Pagination from "@/components/Pagination";
Vue.component("Pagination", Pagination);
// import './assets/styles/element-variables.less'
import { Notification, MessageBox, Message } from "element-ui";
Vue.use(ElementUI);

import Echarts from 'echarts'
Vue.prototype.$echarts = Echarts
Vue.use(Echarts)

import copyright from './components/client/copyright'
import request from "vue-resource/src/http/request";
import fa from "element-ui/src/locale/lang/fa";
import de from "element-ui/src/locale/lang/de";
// 验证码图形插件
import CaptchaMask from "@/components/CaptchaMask";
Vue.component('copyright', copyright)
Vue.component("CaptchaMask", CaptchaMask);
Vue.config.productionTip = false

// Vue.http.options.timeout = 5000  // 超时时间, 默认没限制
Vue.http.interceptors.push((request, next) => {
  request.headers.set('ver', '1.0.3') // 请求headers携带参数
  let token = localStorage.getItem('token')
  // console.log(request.url,'klklkhh')
  if (token && request.url != '/api/sendCodeNew' && request.url != '/api/getWebSiteSetInfo' && request.url != '/api/system/config/getIndexColor')
  {
    request.headers.set('company-Authorization', token) // 请求headers携带参数
  }
  next(function (response) {
    // console.log(response, 'wowowowo')
    if (response.bodyBlob)
    {
      return response
    }
    switch (response.body.code)
    {
      case 200:
        return response
        break
      case 401:
        // window.vm.$message.error('登录失效请重新登录')
        window.vm.$router.push({
          path: './login',
          query: {
            issx: true
          }
        })
        break
      default:
        window.vm.$message.error(response.body.msg)
    }

    // if(response.body.code !== 200) {
    //   window.vm.$message.error(response.body.msg)
    // }
    // if(response.body.code == 401) {
    //   window.vm.$message.error('登录失效请重新登录')
    //   window.vm.$router.push('./login')
    //   return false
    // } else {
    //   return response;
    // }
  })
})

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})







// WEBPACK FOOTER //
// ./src/main.js